<template>
	<div>
		<div class="title">Thank you for your booking! </div>
		<div class="btn" @click="toOrderList">
			<div>Please click <span>HERE</span> to find the details of your order or booking.</div>
			<div>Do not hesitate to email us if you encounter any problems at info@Curiouser-family.com.</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				type:0
			}
		},
		created(){
			if(this.$router.query.type){
				this.type = this.$router.query.type
			}
		},
		methods:{
			toOrderList(){
				this.$router.push('/home/userInfo/orderList')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.title{
		position: relative;
		top: 400px;
		text-align: center;
		font-size: 80px;
	}
	.btn{
		position: relative;
		top: 440px;
		border-radius: 30px;
		text-align: center;
		font-size: 22px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		text-align: center;
		line-height: 60px;
		cursor: pointer;
		div{
			text-align: center;
		}
		span{
			color: #BF5F49;
		}
	}
</style>